import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tag = ({ children, color, size = 'standard' }) => {
  const colors = {
    blue: {
      backgroundColor: '#627ae4',
    },
    green: {
      backgroundColor: '#62d095',
    },
    orange: {
      backgroundColor: '#fda772',
    },
    red: {
      backgroundColor: '#f4736b',
    },
    gray: {
      backgroundColor: '#e1dede',
    },
  };

  const sizes = {
    large: {
      fontSize: '1.2rem',
      borderRadius: '16px',
      padding: '0.375rem 1rem',
    },
    small: {
      fontSize: '0.75rem',
      borderRadius: '12px',
      padding: '0.125rem 0.5rem',
    },
    standard: {
      fontSize: '1rem',
      borderRadius: '12px',
      padding: '0.25rem 0.75rem',
    },
  };

  return (
    <TagContainer size={sizes[size]} color={colors[color]}>
      {children}
    </TagContainer>
  );
};

Tag.propTypes = {
  color: PropTypes.oneOf(['blue', 'green', 'orange', 'red', 'gray']).isRequired,
  size: PropTypes.oneOf(['large', 'small', 'standard']),
  children: PropTypes.node.isRequired,
};

export default Tag;

const TagContainer = styled.span`
  color: #fff;
  font-size: ${({ size }) => size.fontSize};
  font-weight: 500;
  line-height: 1;
  padding: ${({ size }) => size.padding};
  background-color: ${({ color }) => color.backgroundColor};
  border-radius: ${({ size }) => size.borderRadius};
`;
